/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_reststopservice__picnictable3 = /** @type {(inputs: {}) => string} */ () => {
	return `Picknicktisch`
};

const en_reststopservice__picnictable3 = /** @type {(inputs: {}) => string} */ () => {
	return `Picnic table`
};

const es_reststopservice__picnictable3 = /** @type {(inputs: {}) => string} */ () => {
	return `Mesa de picnic`
};

const fr_reststopservice__picnictable3 = /** @type {(inputs: {}) => string} */ () => {
	return `Tables de pique-nique`
};

const it_reststopservice__picnictable3 = /** @type {(inputs: {}) => string} */ () => {
	return `Tavolo da picnic`
};

const nl_reststopservice__picnictable3 = /** @type {(inputs: {}) => string} */ () => {
	return `Picknicktafel`
};

const pt_reststopservice__picnictable3 = /** @type {(inputs: {}) => string} */ () => {
	return `Mesa de piquenique`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const reststopservice__picnictable3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.reststopservice__picnictable3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("reststopservice__picnictable3", locale)
	if (locale === "de") return de_reststopservice__picnictable3(inputs)
	if (locale === "en") return en_reststopservice__picnictable3(inputs)
	if (locale === "es") return es_reststopservice__picnictable3(inputs)
	if (locale === "fr") return fr_reststopservice__picnictable3(inputs)
	if (locale === "it") return it_reststopservice__picnictable3(inputs)
	if (locale === "nl") return nl_reststopservice__picnictable3(inputs)
	return pt_reststopservice__picnictable3(inputs)
};
export { reststopservice__picnictable3 as "restStopService__picnicTable" }